import React, { useState, useEffect } from "react";

const FormBuilderCheckboxElement = ({ field, buttonsColor }) => {
  const [checkboxClicked, setCheckboxClicked] = useState([]);
  const checkboxClickedHandle = (index) => {
    checkboxClicked.includes(index)
      ? setCheckboxClicked(checkboxClicked.filter((item) => item !== index))
      : setCheckboxClicked((prev) => [...prev, index]);
  };
  const returnCheckboxChecked = (color) => {
    return (
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="10"
          height="10"
          rx="0.5"
          fill="white"
          stroke={`${
            color ? (color.includes("#") ? color : "#" + color) : "#15B4D4"
          }`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.76017 4.16534L7.61103 3L4.58994 5.97908L3.15727 4.5464L2 5.70367L4.20022 7.90389L4.21175 7.89236L4.59079 8.27674L8.76017 4.16534Z"
          fill={`${
            color ? (color.includes("#") ? color : "#" + color) : "#15B4D4"
          }`}
        />
      </svg>
    );
  };

  const returnCheckboxUnChecked = (color) => {
    return (
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="10"
          height="10"
          rx="0.5"
          fill="white"
          stroke={`#C7CFD3`}
        />
      </svg>
    );
  };

  useEffect(() => {
    if (checkboxClicked) {
      let temp = "";
      checkboxClicked.forEach((element) => {
        temp += temp === "" ? "" : ",";
        temp += element;
      });
    }
  }, [checkboxClicked]);
  return (
    <div className="checklist">
      {field.fields.checkboxes &&
        field.fields.checkboxes.map((item, i) => (
          <div
            tabIndex={0}
            key={i}
            className="checkbox-item"
            onClick={() => checkboxClickedHandle(i)}
          >
            <label>
              {checkboxClicked.includes(i)
                ? returnCheckboxChecked(buttonsColor)
                : returnCheckboxUnChecked(buttonsColor)}
              {item}
            </label>
          </div>
        ))}
    </div>
  );
};

export default FormBuilderCheckboxElement;
